/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Logistics_Order_Pipeline_DescriptionInputs */

const en_logistics_order_pipeline_description = /** @type {(inputs: Logistics_Order_Pipeline_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Breakdown of orders by current status`)
};

const es_logistics_order_pipeline_description = /** @type {(inputs: Logistics_Order_Pipeline_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desglose de pedidos por estado actual`)
};

/**
* | output |
* | --- |
* | "Breakdown of orders by current status" |
*
* @param {Logistics_Order_Pipeline_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const logistics_order_pipeline_description = /** @type {((inputs?: Logistics_Order_Pipeline_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Logistics_Order_Pipeline_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_logistics_order_pipeline_description(inputs)
	return es_logistics_order_pipeline_description(inputs)
});